import { CrosshairsIcon } from './CrosshairsIcon';

/**
 * author: Google
 * id 33845FDE-0003-4780-8DC9-07FC29D46599
 * name crosshairs
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crosshairs.svg
 * tags
 * - Geographic Information System 
 */
export const GpsNotFixedIcon = CrosshairsIcon;
export default GpsNotFixedIcon